'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaWheelchairAlt = function FaWheelchairAlt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.1 18.1q0.8 0.8 0.6 1.9l-0.9 12.3q-0.1 0.9-0.8 1.5t-1.6 0.7q-0.1 0-0.2-0.1-1 0-1.6-0.8t-0.6-1.7l0.8-9.6-3.2 0.2q1.2 2.5 1.2 5.4 0 4.8-3.3 8.3l-3-3.1q2-2.3 2-5.2 0-3.3-2.3-5.6t-5.5-2.3q-3 0-5.3 2.1l-3-3.1q2.6-2.5 6.3-3.1l5.9-6.7-3.3-2-4.1 3.6q-0.7 0.7-1.7 0.6t-1.6-0.8-0.6-1.7 0.8-1.6l5.3-4.8q0.6-0.5 1.3-0.6t1.5 0.4l10.8 6.3q0.9 0.4 1.1 1.5 0.4 1.5-0.6 2.6l-4.5 5.2 8.2-0.5q1.1 0 1.9 0.8z m-4.4-10.2q-1.7 0-2.8-1.1t-1.2-2.8 1.2-2.8 2.8-1.2 2.8 1.2 1.2 2.8-1.2 2.8-2.8 1.1z m-14 27.8q2.3 0 4.4-1.4l3.1 3.1q-3.3 2.6-7.5 2.6-3.3 0-6.1-1.6t-4.5-4.5-1.6-6q0-4.2 2.6-7.5l3.1 3.1q-1.3 1.9-1.3 4.4 0 3.2 2.3 5.5t5.5 2.3z' })
        )
    );
};

exports.default = FaWheelchairAlt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/wheelchair-alt.js
// module id = 1839
// module chunks = 0